










































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import moment from "moment";
import { Bidui } from "@/request/tongue";
import PicPreview from "@/components/pic-preview.vue";
@Component({
  components: {
    PicPreview,
  },
})
export default class BiduiResult extends Vue {
  // 选择舌图
  private selectedTongues: any[] = [];
  private ifShowBiaozhu: boolean = false;
  private tempUrl: any = "";
  private ifShowPreview: boolean = false;
  private cDingxing: any = "舌色";
  private cJihe: any = "舌上红点";
  private loaded: boolean = false;
  private result: any = {};
  private dingxing: any = {
    legend: {
      show: false,
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      type: "category",
    },
    tooltip: {
      formatter: (params) => {
        return params["name"] + "-" + params["data"]["tag"];
      },
    },
    dataZoom: [
      {
        xAxisIndex: 0,
      },
      {
        yAxisIndex: 0,
      },
    ],
    grid: {
      bottom: 20,
      top: 10,
    },
    series: [
      {
        type: "line",
        data: [],
        clip: false,
        // label: {
        //   normal: {
        //     show: true,
        //     formatter: (params) => {
        //       return params["data"]["tag"];
        //     },
        //   },
        // },
      },
    ],
  };
  private jihe: any = {
    legend: {
      show: false,
    },
    xAxis: {
      type: "category",
    },
    yAxis: [
      {
        type: "value",
        position: "right",
        name: "占比",
      },
      {
        type: "value",
        position: "left",
        name: "数量",
      },
    ],
    tooltip: {},
    dataZoom: [
      {
        xAxisIndex: 0,
      },
      {
        yAxisIndex: [0, 1],
      },
    ],
    grid: {
      bottom: 20,
      top: 30,
    },
    series: [
      {
        type: "bar",
        data: [],
        yAxisIndex: 0,
      },
      {
        type: "line",
        data: [],
        yAxisIndex: 1,
      },
    ],
  };
  private scatterOption: any = {
    grid3D: {
      boxWidth: 100,
      boxHeight: 100,
      viewControl: {
        projection: "orthographic",
        orthographicSize: 300,
      },
    },
    xAxis3D: {
      name: "",
      type: "value",
      min: -10,
      max: 160,
      minInterval: 1,
      nameGap: 60,
      nameTextStyle: {
        color: "red",
      },
    },
    yAxis3D: {
      name: "",
      type: "value",
      min: 0,
      max: 160,
      minInterval: 1,
      nameGap: 60,
      nameTextStyle: {
        color: "red",
      },
    },
    zAxis3D: {
      name: "",
      type: "value",
      min: -5,
      max: 160,
      minInterval: 1,
      nameGap: 60,
      nameTextStyle: {
        color: "red",
      },
    },
    series: [
      {
        type: "scatter3D",
        symbolSize: 12,
        itemStyle: {
          borderWidth: 1,
          borderColor: "rgba(255,255,255,0.8)",
        },
        emphasis: {
          itemStyle: {
            color: "#fff",
          },
          label: {
            show: true,
            formatter: (params: any) => {
              return `l:${params.value[0]};a:${params.value[1]};b:${params.value[2]}`;
            },
          },
        },
      },
    ],
  };
  private shese: any = {};
  private taise: any = {};
  /**
   * @description 跳转智能标注
   */
  private jumpBiaozhu() {
    this.$router.push("/main/tongue/tongue-list");
  }
  /**
   * @description 跳转到智能比对报告
   */
  private jumpBiduiPreview() {
    localStorage.setItem("biduiTime", moment().format('yyyy-MM-DD HH:mm:ss'));
    this.$router.push("/main/tongue/bidui-preview");
  }
  /**
   * @description 获得比对结果
   */
  private fetchResult() {
    this.loaded = false;
    const arr: any[] = [];
    this.selectedTongues.forEach((item: any) => {
      arr.push(item.tongue_id);
    });
    if (arr.length >= 2) {
      const params: any = {
        tongue_ids: arr,
      };
      Bidui(this, params).then((data: any) => {
        console.log(data);
        this.result = data;
        this.loaded = true;
        this.createDingxing();
        this.createJihe();
        this.createScatters();
      });
    }
  }
  /**
   * @description 打开图片预览
   */
  private showPreview(src) {
    this.tempUrl = src;
    this.ifShowPreview = true;
  }
  /**
   * @description 切换定性特征部分
   */
  private triggerDingxing(part) {
    this.cDingxing = part;
    this.createDingxing();
  }
  /**
   * @description 创建定性线图
   */
  private createDingxing() {
    this.dingxing.xAxis.data = this.result["定性特征参数变化趋势图"][
      this.cDingxing
    ]["name"];
    this.dingxing.yAxis.data = this.result["定性特征参数变化趋势图"][
      this.cDingxing
    ]["y"];
    this.dingxing.series[0].data = this.result["定性特征参数变化趋势图"][
      this.cDingxing
    ]["data"];
  }
  /**
   * @description 切换几何特征部分
   */
  private triggerJihe(part) {
    this.cJihe = part;
    this.createJihe();
  }
  /**
   * @description 创建几何柱状图
   */
  private createJihe() {
    this.jihe.xAxis.data = this.result["几何特征参数变化趋势图"][this.cJihe][
      "name"
    ];
    this.jihe.series[0].data = this.result["几何特征参数变化趋势图"][
      this.cJihe
    ]["占比"];
    this.jihe.series[1].data = this.result["几何特征参数变化趋势图"][
      this.cJihe
    ]["数量"];
  }
  /**
   * @description 创建单个3D散点图
   */
  private createScatter(result, key) {
    const obj = _.cloneDeep(this.scatterOption);
    let lmin = 200;
    let lmax = -100;
    let ltemp;
    let amin = 200;
    let amax = -100;
    let atemp;
    let bmin = 200;
    let bmax = -100;
    let btemp;
    obj.series[0].data = result[key].map((item: any) => {
      ltemp = item[0];
      atemp = item[1];
      btemp = item[2];
      lmin = lmin <= ltemp ? lmin : ltemp;
      lmax = lmax >= ltemp ? lmax : ltemp;
      amin = amin <= atemp ? amin : atemp;
      amax = amax >= atemp ? amax : atemp;
      bmin = bmin <= btemp ? bmin : btemp;
      bmax = bmax >= btemp ? bmax : btemp;
      return {
        value: [item[1], item[2], item[0]],
        itemStyle: {
          color: item[3],
        },
      };
    });
    obj.zAxis3D.min = Math.floor(lmin);
    obj.zAxis3D.max = Math.ceil(lmax);
    obj.xAxis3D.min = Math.floor(amin);
    obj.xAxis3D.max = Math.ceil(amax);
    obj.yAxis3D.min = Math.floor(bmin);
    obj.yAxis3D.max = Math.ceil(bmax);
    return obj;
  }
  /**
   * @description 创建3D散点图
   */
  private createScatters() {
    this.shese = this.createScatter(this.result, "舌色三维空间比对图");
    this.shese.zAxis3D.name = "L";
    this.shese.xAxis3D.name = "A";
    this.shese.yAxis3D.name = "B";
    this.taise = this.createScatter(this.result, "苔色三维空间比对图");
    this.taise.zAxis3D.name = "L";
    this.taise.xAxis3D.name = "A";
    this.taise.yAxis3D.name = "B";
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const arr = localStorage.getItem("selectedTongues");
    if (arr) {
      this.selectedTongues = JSON.parse(arr);
      console.log(this.selectedTongues);
      this.fetchResult();
    }
  }
}
